module.exports = __webpack_public_path__ + "img/18.c45d8e22.jpg";